import { createFileRoute } from '@tanstack/react-router';

import { ResetPasswordPage } from '../modules/auth/ui/pages/ResetPasswordPage';

export const Route = createFileRoute('/reset-password/$token')({
  component: ResetPasswordPage,
});
